import { useEffect, useRef } from 'react';
import { Animated, Easing, Pressable, View } from 'react-native';
import { Icon } from '@/components/Icon';
import { Text } from '@/components/Text';
import colors from '@/config/colors';
import { styles } from './styles';

interface ExpandableSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  content: string;
}

export const ExpandableSection: React.FC<ExpandableSectionProps> = ({
  isExpanded,
  onToggle,
  content,
}) => {
  const rotateAnim = useRef(new Animated.Value(0)).current;

  const rotate = rotateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '180deg'],
  });

  useEffect(() => {
    Animated.timing(rotateAnim, {
      toValue: isExpanded ? 1 : 0,
      duration: 300,
      easing: Easing.inOut(Easing.ease),
      useNativeDriver: true,
    }).start();
  }, [isExpanded, rotateAnim]);

  return (
    <View style={{ gap: 16 }}>
      <Pressable
        style={styles.expandableSectionTitle}
        onPress={() => onToggle()}
      >
        <Text style={styles.expandableSectionText}>
          {isExpanded ? 'ausblenden' : 'anzeigen'}
        </Text>
        <Animated.View style={{ transform: [{ rotate }] }}>
          <Icon
            name="chevronDown"
            size={26}
            color={colors.newUI.therapist.primaryBlue80}
          />
        </Animated.View>
      </Pressable>

      {isExpanded && <Text>{content}</Text>}
    </View>
  );
};
